import React from "react";
import styles from "./Login.module.scss";
import { useLoginPageHook } from "../../hooks/useLoginPageHook";

const LoginPage = () => {
  const {
    formState: { email, password, rememberMe },
    handleInputChange,
    handleSubmit,
    emailInputRef,
  } = useLoginPageHook();

  return (
    <div className={styles.loginForm}>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          id="email"
          name="email"
          className={styles.input}
          placeholder="Email"
          value={email}
          onChange={handleInputChange}
          ref={emailInputRef}
        />
        <input
          type="password"
          id="password"
          name="password"
          className={styles.input}
          placeholder="Password"
          value={password}
          onChange={handleInputChange}
        />
        <label className={styles.loginForm__remember}>
          <input
            type="checkbox"
            name="rememberMe"
            checked={rememberMe}
            onChange={handleInputChange}
          />
          Запомнить меня
        </label>
        <button type="submit" className={styles.loginForm__submit}>
          Sign in
        </button>
      </form>
    </div>
  );
};

export default LoginPage;
